module.exports = __webpack_public_path__ + "static/media/Work.16df13a0.gif";